import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES}` as const;

export const EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES = {
  PRODUCT_VALUE: 'productsValue',
} as const;

export interface IProductsOrServicesExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE]: string;
}

export const productsOrServicesExecutiveSummaryInitialValues: IProductsOrServicesExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE]: '',
};
